<div class="titulo-receber-referencia-data-select dropdown">
    <button class="btn btn-light dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"
        [disabled]="disabled">
        <ng-template [ngIf]="referencia">
            <span>
                {{referencia.nome}}
            </span>
        </ng-template>

        <ng-template [ngIf]="!referencia">
            <span>
                Nenhuma Referência
            </span>
        </ng-template>        
    </button>
    
    <div class="dropdown-menu-container">
        <div class="dropdown-menu">
            <div class="dropdown-menu-itens">
                <a class="dropdown-item" 
                    *ngIf="canSelectNull"
                    [class.dropdown-item-select]="!idReferencia"
                    (click)="select(null)">
                    Nenhuma Referência
                </a>
                <a *ngFor="let temp of referencias" 
                    class="dropdown-item"
                    [class.dropdown-item-select]="temp.id == idReferencia"
                    (click)="select(temp)">                 
                    {{temp.nome}}
                </a>
            </div>
        </div>        
    </div>
</div>